import { useState } from "react";
import { verifyOtp } from "../../store/thunks/authThunks";
import { useThunk } from "../../hooks/useThunk";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import showToast from "../../utils/toastNotifications";
import loginImage from "../../assets/Login/image1.png";
import LoginImageMobile from "../../assets/Login/mobilebg.svg";
import LoginImageTab from "../../assets/Login/bluebg-tabs.png";
import blueBg from "../../assets/Login/bluebg.svg";

const Otp = () => {
  const navigate = useNavigate();

  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [isTrusted, setIsTrusted] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false); // State for tooltip
  const [showErrorColor, setShowErrorColor] = useState(false);

  const [doVerifyOtp, isLoading, otpError] = useThunk(verifyOtp);

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return;

    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    // Move to the next input field
    if (element.nextElementSibling && element.value) {
      element.nextElementSibling.focus();
    }
    setShowErrorColor(false);
  };

  const handleSubmit = async () => {
    const result = await doVerifyOtp({
      otp: otp.join(""),
      trustThisDevice: isTrusted,
    });
    console.log(result);

    if (result.success) {
      showToast("success", result.response.message);
      localStorage.setItem("token", result.response.data.token);
      navigate("/", { replace: true });
    } else {
      showToast("error", result?.error?.message);
      setShowErrorColor(true);
    }
  };

  return (
    <div className="flex flex-col min-w-[403px] relative w-full h-screen overflow-x-hidden">
      {/* WatermarkBg*/}
      <div className="lg:hidden absolute right-0 w-[60%]">
        <img
          src={LoginImageMobile}
          alt="background"
          className="sm:hidden w-full"
        />
        <img
          src={LoginImageTab}
          alt="background"
          className="hidden sm:block ml-[40px] w-full"
        />
      </div>

      <div className="absolute z-0 top-0 right-0 w-full login-br:block">
        <img
          src={blueBg}
          alt="background"
          className="hidden lg:block absolute -right-15 -top-20 lg:right-0 w-full  lg:max-w-[650px] xl:max-w-[700px] 2xl:max-w-[750px] 1920-br:max-w-[850px] 2560-br:max-w-[1400px] transition-all duration-300"
        />
      </div>

      {/* Left Section */}
      <div className="relative z-10 mx-auto flex flex-grow mt-24 md:mt-0 items-start md:items-center justify-center login-br:justify-between w-full 2xl:max-w-[1536px] auth-layout-structure-in-tab-screen-higher-than-880-height">
        <div className="w-full lg:w-[90%] 2xl:w-[60%] flex flex-col justify-center px-10 lg:px-20 ml-0 1920-br:translate-x-[80px]">
          {/* Heading */}
          <div className="">
            <h1 className="text-level-1 font-roboto font-bold leading-[44px] text-primary mb-2">
              Enter OTP{" "}
            </h1>
            <p className="mb-0 sm:mb-10 font-inter text-[18px] text-gray max-w-[200px] sm:max-w-[300px] md:max-w-none">
              Enter the OTP sent to your Email Address
            </p>
          </div>

          <div className="w-full sm:max-lg:w-[55%] mr-10 max-sm:mt-8 ">
            {/* Input Feilds */}
            <div className="flex w-full ">
              {otp.map((data, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength="1"
                  value={data}
                  onChange={(e) => handleChange(e.target, index)}
                  onFocus={(e) => e.target.select()}
                  style={{
                    border:
                      otpError && showErrorColor
                        ? "1px solid #ff0000"
                        : "1px solid #ccc",
                  }}
                  className="w-[40px] h-[40px] md:w-[48px] md:h-[48px] lg:w-[52px] lg:h-[52px] xl:w-[60px]   xl:h-[60px] mr-2 xl:mr-4 text-center text-[18px] border-2 outline-none rounded-[8px]"
                />
              ))}
            </div>

            {/* Remeber Me */}
            <div className="font-inter text-black/50 mt-[24px] flex items-center space-x-2">
              <input
                type="checkbox"
                id="trustDevice"
                checked={isTrusted}
                onChange={(e) => setIsTrusted(e.target.checked)}
                className="w-4 h-4 accent-[#6D758F] rounded"
              />
              <label
                htmlFor="trustDevice"
                className=" font-lato  text-[15px] text-center leading-[18.75px] text-black/50"
              >
                Trust this device
              </label>
              <div className="bg-blue-shades relative rounded-full flex items-center justify-center h-5 w-5">
                <span
                  onClick={() => setShowTooltip(!showTooltip)}
                  className="text-white cursor-pointer"
                >
                  ?
                </span>
                {showTooltip && (
                  <div className="absolute top-8 left-1/2 transform -translate-x-1/2 bg-gray-800 border border-gray text-gray text-sm rounded-md p-2 shadow-lg w-48">
                    <div className="absolute left-1/2 transform -translate-x-1/2 top-[-8px] w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-gray rotate-180"></div>
                    You won't need to verify OTP again on this device if you
                    trust it.
                  </div>
                )}
              </div>
            </div>

            {/* Submit Button */}
            <div className="sm:mr-10 lg:mr-0 mt-[80px]">
              <button
                onClick={handleSubmit}
                disabled={isLoading}
                className={` w-full md:w-[328px] lg:w-[352px] xl:w-[440px]  font-inter mt-[56px] font-semibold text-[18px] leading-[21.6px] bg-blue-shades text-white py-3 rounded-lg hover:bg-[#060073] transition duration-200 `}
              >
                {isLoading ? "Verifying..." : "Submit"}
              </button>
            </div>
          </div>
        </div>

        {/* Right Side: Image */}
        <div className="hidden lg:flex items-center justify-center w-full md:max-w-[480px] lg:max-w-[580px] xl:max-w-[650px] max-1440-br:-translate-y-32 1920-br:-translate-x-[80px]">
          <img src={loginImage} alt="Sign Up" />
        </div>
      </div>
    </div>
  );
};

export default Otp;
